import React, { useCallback, useMemo } from 'react';
import { orderBy } from 'lodash';
import Statuses from '../../../../model/Statuses';
import TreeSelectorTooltip from '../NextTree/TreeSelectorTooltip/TreeSelectorTooltip';
import ValueView from './ValueView';
import nodeSortingOptionsSequence from '../../../utils/nodeSortingOptionsSequence';
const MAX_VISIBLE_NAMES = 2;
export default function SubtreeValueView({ selection, viewSelector, label, models = [], adapter = {}, syntheticRootNodeName, maxVisibleNames = MAX_VISIBLE_NAMES, hasTitle = false, }) {
    const resolveNodeTitle = useCallback(node => {
        if (adapter.resolveNodeTitle) {
            return adapter.resolveNodeTitle(node);
        }
        return node.name;
    }, [adapter]);
    const resolveTitleWithStatus = useCallback(item => {
        const status = (item.status && item.status === Statuses.Active.value) ||
            !Statuses.BasicByValue[item.status]
            ? ''
            : ` (${Statuses.BasicByValue[item.status].name})`;
        return `${resolveNodeTitle(item)}${status}`;
    }, [resolveNodeTitle]);
    const { valueView, title } = useMemo(() => {
        const _selection = viewSelector || selection;
        if (!_selection) {
            return {
                valueView: '',
                title: '',
            };
        }
        const items = orderBy(Array.isArray(_selection) ? _selection : [_selection], nodeSortingOptionsSequence.iteratees, 'asc');
        if (!items.length) {
            return {
                valueView: 'None',
                title: 'None',
            };
        }
        const valueView = items
            .slice(0, maxVisibleNames)
            .map(resolveTitleWithStatus);
        const title = items.map(resolveTitleWithStatus);
        if (items.length > maxVisibleNames) {
            valueView.push('...');
        }
        return {
            valueView: valueView.join(', '),
            title: title.join(', '),
        };
    }, [maxVisibleNames, viewSelector, selection, resolveTitleWithStatus]);
    const renderAddon = useCallback(() => (<TreeSelectorTooltip isRenderOnlySelected adapter={adapter} models={models} selection={selection} syntheticRootNodeName={syntheticRootNodeName}/>), [selection, adapter, models, syntheticRootNodeName]);
    return (<ValueView label={label} noLabel={!label} renderAddon={renderAddon} title={(hasTitle && title) || undefined} value={valueView}/>);
}
